import { FunctionComponent } from "react";
import { Body1, Modal, styled } from "@horizontal-org/shira-ui";
import { useTranslation } from "react-i18next";

interface Props {
  isModalOpen: boolean;
  onClose: () => void;
  onPublish?: () => void;
}

export const PublishQuizAction: FunctionComponent<Props> = ({
  isModalOpen,
  onClose,
  onPublish,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      id="publish-private-quiz-modal"
      isOpen={isModalOpen}
      title={t('modals.publish_quiz.title')}
      primaryButtonText={t('modals.publish_quiz.submit')}
      secondaryButtonText={t('modals.publish_quiz.close')}
      onPrimaryClick={onPublish}
      onSecondaryClick={onClose}
    >
      <BodyWrapper>
        <Body1 id="publish-private-quiz-subtitle-1">{t('modals.publish_quiz.private_subtitle_1')}</Body1>
        <Body1 id="publish-private-quiz-subtitle-2">{t('modals.publish_quiz.private_subtitle_2')}</Body1>
      </BodyWrapper>
    </Modal>
  );
};

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;